import { ProductOP, CombinationOP, IContact, IShipmentLocation, UnitV2 } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import {
  ImApplication,
  CatalogSlumpsResponse,
  ImSpacing,
  ImUnloadTime,
  ImUnloadType,
  ImSlump,
  ImLoadSize,
} from '@cemex-core/cmx-api';

import OrdersCatalogsActions from '../actions/orders-catalogs.action';
import { ImFeature, ImPumpCapacity } from '@cemex-core/cmx-api/models/catalogs/catalogs-response';

export interface State {
  loading: boolean;
  // mix
  availableProducts: ProductOP[];
  valuesAddedNotCombinable: CombinationOP[];
  // static data
  applications: ImApplication[];
  unloadTypes: ImUnloadType[];
  pumpCapacities: ImPumpCapacity[];
  spacings: ImSpacing[];
  filterSpacings: ImSpacing[];
  loadSizes: ImLoadSize[];
  contacts: IContact[];
  // pending revision of utility
  unloadTimes: ImUnloadTime[];
  filteredUnloadTimes: ImUnloadTime[];
  filteredUnloadTypes: ImUnloadType[];
  slumps: ImSlump[];
  filteredSlumps: ImSlump[];
  slumpProduct: {
    [productCode: string]: CatalogSlumpsResponse;
  };
  pumpabilities: {
    id: number;
    name: string;
  }[];
  filteredPumpability: {
    id: number;
    name: string;
  }[];
  pointOfDeliveries: IShipmentLocation[];
  featureTemperature: ImFeature[];
  featureIceQuantity: ImFeature[];
  featurePumpPrimer: ImFeature[];
  unitByProductMap: {
    count?: number;
    items?: { [productCode: string]: UnitV2[] };
  };
  error: any;
}

export const initialState: State = {
  loading: false,
  availableProducts: [],
  valuesAddedNotCombinable: [],
  applications: [],
  spacings: [],
  filterSpacings: [],
  unloadTimes: [],
  filteredUnloadTimes: [],
  unloadTypes: [],
  pumpCapacities: [],
  filteredUnloadTypes: [],
  slumps: [],
  filteredSlumps: [],
  pumpabilities: [
    {
      id: 0,
      name: `0`,
    },
    {
      id: 1,
      name: `1`,
    },
    {
      id: 2,
      name: `2`,
    },
    {
      id: 3,
      name: `3`,
    },
  ],
  filteredPumpability: [
    {
      id: 0,
      name: `0`,
    },
    {
      id: 1,
      name: `1`,
    },
    {
      id: 2,
      name: `2`,
    },
    {
      id: 3,
      name: `3`,
    },
  ],
  slumpProduct: null,
  loadSizes: [],
  contacts: [],
  pointOfDeliveries: [],
  featureTemperature: [],
  featureIceQuantity: [],
  error: null,
  featurePumpPrimer: [],
  unitByProductMap: {
    count: 0,
  },
};

export const ordersCatalogsReducer = createReducer(
  initialState,

  on(OrdersCatalogsActions.LoadApplicationCatalogAction, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadApplicationCatalogCompleteAction, (state, { payload }) => {
    return {
      ...state,
      applications: payload,
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadMix, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadMixSuccess, (state, { payload, valuesAddedNotCombinable }) => {
    return {
      ...state,
      availableProducts: payload,
      valuesAddedNotCombinable: valuesAddedNotCombinable,
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadPumpCapacityCatalogAction, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadUnloadTypeCatalogAction, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadUnloadTypeCatalogCompleteAction, (state, { payload }) => {
    return {
      ...state,
      unloadTypes: payload,
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadPumpCapacityCatalogCompleteAction, (state, { payload }) => {
    return {
      ...state,
      pumpCapacities: payload,
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadSpacingCatalogAction, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadSpacingCatalogCompleteAction, (state, { payload }) => {
    return {
      ...state,
      spacings: payload,
      filterSpacings: payload,
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadLoadSizeCatalogAction, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadLoadSizeCatalogCompleteAction, (state, { payload }) => {
    return {
      ...state,
      loadSizes: payload,
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadSlumpProductCatalogAction, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadSlumpProductCatalogCompleteAction, (state, { payload }) => {
    return {
      ...state,
      slumpProduct: {
        ...state.slumpProduct,
        ...payload,
      },
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadContactsAction, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadContactsSuccessAction, (state, { payload }) => {
    return {
      ...state,
      contacts: payload,
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.SingleCatalogsErrorAction, (state, { payload }) => {
    return {
      ...state,
      error: payload,
    };
  }),

  on(OrdersCatalogsActions.SingleCatalogsResetAction, (state) => ({
    ...initialState,
  })),

  on(OrdersCatalogsActions.LoadUnloadTimeCatalogCompleteAction, (state, { payload }) => {
    return {
      ...state,
      unloadTimes: payload,
      filteredUnloadTimes: payload,
      loading: false,
      error: null,
    } as State;
  }),
  on(OrdersCatalogsActions.LoadUnloadTimeFilteredCompleteAction, (state, { payload }) => {
    return {
      ...state,
      filteredUnloadTimes: payload,
      loading: false,
      error: null,
    } as State;
  }),
  on(OrdersCatalogsActions.LoadPointOfDeliverySuccessAction, (state, { payload }) => {
    return {
      ...state,
      pointOfDeliveries: payload,
      loading: false,
      error: null,
    } as State;
  }),
  on(OrdersCatalogsActions.PointOfDeliveryAddEntity, (state, { payload }) => {
    return {
      ...state,
      pointOfDeliveries: [payload, ...state.pointOfDeliveries],
      loading: false,
      error: null,
    } as State;
  }),
  on(OrdersCatalogsActions.LoadFeatureTemperatureCatalogCompletedAction, (state, { payload }) => {
    return {
      ...state,
      featureTemperature: payload,
      loading: false,
      error: null,
    } as State;
  }),
  on(OrdersCatalogsActions.LoadFeaturePumpPrimerSuccessAction, (state, { payload }) => {
    return {
      ...state,
      featurePumpPrimer: payload,
      loading: false,
      error: null,
    } as State;
  }),
  on(OrdersCatalogsActions.LoadFeatureIceQuantityCatalogCompletedAction, (state, { payload }) => {
    return {
      ...state,
      featureIceQuantity: payload,
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.PointOfDeliveryDeleteById, (state, { payload }) => {
    return {
      ...state,
      pointOfDeliveries: state.pointOfDeliveries.filter((pod) => pod.shipmentLocationId !== payload),
    };
  }),
  on(OrdersCatalogsActions.LoadProductUnitMappingSuccessAction, (state, { payload }) => {
    return {
      ...state,
      unitByProductMap: {
        ...state.unitByProductMap,
        count: (state.unitByProductMap.count ?? 0) + 1,
        items: {
          ...state.unitByProductMap.items,
          [payload.productCode]: payload.units,
        },
      },
      loading: false,
      error: null,
    } as State;
  }),

  on(OrdersCatalogsActions.LoadProductUnitMappingFailureAction, (state, { payload }) => {
    return {
      ...state,
      error: null,
    };
  }),
);

export function reducer(state: State | undefined, action: Action) {
  return ordersCatalogsReducer(state, action);
}
